import React from 'react'
import { motion } from 'framer-motion'

const MOCKUP_TEMPLATES = [
  {
    id: 'paperback-front',
    name: 'Paperback - Front View',
    category: 'paperback',
    preview: '/api/placeholder/200/300',
    description: 'Clean front view perfect for listings'
  },
  {
    id: 'paperback-angle',
    name: 'Paperback - Angled',
    category: 'paperback',
    preview: '/api/placeholder/200/300',
    description: '3D perspective with shadow'
  },
  {
    id: 'paperback-stack',
    name: 'Paperback - Stack',
    category: 'paperback',
    preview: '/api/placeholder/200/300',
    description: 'Multiple copies stacked'
  },
  {
    id: 'hardcover-standing',
    name: 'Hardcover - Standing',
    category: 'hardcover',
    preview: '/api/placeholder/200/300',
    description: 'Premium hardcover display'
  },
  {
    id: 'hardcover-open',
    name: 'Hardcover - Open',
    category: 'hardcover',
    preview: '/api/placeholder/200/300',
    description: 'Showing dust jacket and pages'
  },
  {
    id: 'ipad-portrait',
    name: 'iPad - Portrait',
    category: 'ereader',
    preview: '/api/placeholder/200/300',
    description: 'iPad in portrait orientation'
  },
  {
    id: 'iphone-portrait',
    name: 'iPhone - Portrait',
    category: 'ereader',
    preview: '/api/placeholder/200/300',
    description: 'iPhone reading app mockup'
  },
  {
    id: 'kindle-oasis',
    name: 'Kindle Oasis',
    category: 'ereader',
    preview: '/api/placeholder/200/300',
    description: 'E-ink display simulation'
  },
  {
    id: 'android-tablet',
    name: 'Android Tablet',
    category: 'ereader',
    preview: '/api/placeholder/200/300',
    description: 'Android reading experience'
  }
]

const MockupTemplates = ({ selectedTemplate, onSelectTemplate, coverImage }) => {
  const categories = [
    { id: 'all', name: 'All Templates', count: MOCKUP_TEMPLATES.length },
    { id: 'paperback', name: 'Paperback', count: MOCKUP_TEMPLATES.filter(t => t.category === 'paperback').length },
    { id: 'hardcover', name: 'Hardcover', count: MOCKUP_TEMPLATES.filter(t => t.category === 'hardcover').length },
    { id: 'ereader', name: 'E-Readers', count: MOCKUP_TEMPLATES.filter(t => t.category === 'ereader').length }
  ]

  const [selectedCategory, setSelectedCategory] = React.useState('all')

  const filteredTemplates = selectedCategory === 'all' 
    ? MOCKUP_TEMPLATES 
    : MOCKUP_TEMPLATES.filter(t => t.category === selectedCategory)

  return (
    <div className="space-y-6">
      <div>
        <h3 className="text-lg font-semibold text-gray-900 mb-4">Choose Mockup Style</h3>
        
        {/* Category Filters */}
        <div className="flex flex-wrap gap-2 mb-6">
          {categories.map((category) => (
            <button
              key={category.id}
              onClick={() => setSelectedCategory(category.id)}
              className={`
                px-4 py-2 rounded-lg text-sm font-medium transition-colors
                ${selectedCategory === category.id
                  ? 'bg-primary-600 text-white'
                  : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                }
              `}
            >
              {category.name} ({category.count})
            </button>
          ))}
        </div>
      </div>

      {/* Template Grid */}
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
        {filteredTemplates.map((template) => (
          <motion.div
            key={template.id}
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            className={`
              relative bg-white rounded-lg border-2 cursor-pointer transition-all
              ${selectedTemplate?.id === template.id
                ? 'border-primary-500 shadow-lg'
                : 'border-gray-200 hover:border-primary-300'
              }
            `}
            onClick={() => onSelectTemplate(template)}
          >
            <div className="aspect-[3/4] bg-gray-100 rounded-t-lg overflow-hidden">
              {/* Template Preview */}
              <div className="w-full h-full bg-gradient-to-br from-gray-200 to-gray-300 flex items-center justify-center">
                <div className="text-gray-500 text-xs text-center p-2">
                  {template.name}
                  <br />
                  Preview
                </div>
              </div>
            </div>
            
            <div className="p-3">
              <h4 className="font-medium text-gray-900 text-sm mb-1">
                {template.name}
              </h4>
              <p className="text-xs text-gray-600">
                {template.description}
              </p>
            </div>

            {selectedTemplate?.id === template.id && (
              <div className="absolute top-2 right-2 w-6 h-6 bg-primary-600 rounded-full flex items-center justify-center">
                <div className="w-2 h-2 bg-white rounded-full" />
              </div>
            )}
          </motion.div>
        ))}
      </div>

      {!coverImage && (
        <div className="text-center py-8 text-gray-500">
          <p>Upload a book cover to see live previews</p>
        </div>
      )}
    </div>
  )
}

export default MockupTemplates